module.exports = __webpack_public_path__ + "images/tencent_docs/form-3a2876ad8880620247e1a03b50950542.svg";